import axios from "axios";
import { baseURL } from "./config";
axios.defaults.baseURL = baseURL; // 测试
// axios.defaults.baseURL = 'https://wevip.beautyfarm.com.cn';    // 正式
axios.defaults.timeout = 30000;
axios.defaults.headers["Content-Type"] = "multipart/form-data; charset=UTF-8";
import store from "@/store";

axios.interceptors.request.use(
    config => {
        // 思妍丽token判断
        if (config.baseURL.indexOf('scrm-server') !== -1) {
            config.headers['Authorization'] = store.state.scrm.token || ''
        }else{
            config.headers['Authorization'] = store.state.user.token || ''
        }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);


axios.interceptors.response.use(
  response => {
    return response.data;
  },
  error => {
    console.log(error);
    const result = { error: true };
    const { response } = error;
    if (response) {
      if (
        error.code === "ECONNABORTED" &&
        error.message.indexOf("timeout") !== -1
      ) {
        result.err_str = "请求超时，请检查网络再重新连接";
      } else if (error.response.status == 400) {
        result.err_str = error.response.data;
      } else if (error.response.status == 401) {
        result.err_str = "您没有权限访问";
        window.localStorage.setItem("Authorization", "");
      } else if (error.response.status == 500) {
        result.err_str = "服务器错误";
      } else {
        result.err_str = "错误";
      }
      return result;
    } else {
      result.code = 1000000;
      result.msg = "暂无网络，请检查网络";
      return result;
    }
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/api/axiosFun.js